import { render, staticRenderFns } from "./labelAuditList.vue?vue&type=template&id=a3bd43cc&scoped=true"
import script from "./labelAuditList.vue?vue&type=script&lang=js"
export * from "./labelAuditList.vue?vue&type=script&lang=js"
import style0 from "./labelAuditList.vue?vue&type=style&index=0&id=a3bd43cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3bd43cc",
  null
  
)

export default component.exports